require("./style.css");
import React from "react";
import AcquireWebComponent from "../../framework/MaterialUI";
import PieChartTable from "./PieChartTable";

class SegmentDeviceReport extends AcquireWebComponent {
  render() {
    const {
      style,
      top5OSBreakDown,
      deviceModelData,
      deviceTypeData,
      printTitle,
    } = this.props;
    if (deviceTypeData)
      return (
        <div>
          <div
            style={{
              display: "none",
              padding: "20px",
              background: "#D9DBDD",
              color: "#000",
              fontWeight: "bold",
              marginTop: "20px",
            }}
            className="pdf-extra-container"
          >
            {printTitle}
          </div>
          <div style={style} id="device-report-container">
            <div style={{ flex: "50%" }}>
              {this.props.loadDeviceTypeReport && (
                <div
                  className="text-center"
                  style={{ marginTop: "50px", marginBottom: "40px" }}
                >
                  <img alt="" src="/Spinner.gif" style={{ height: "48px" }} />
                </div>
              )}
              <div className="light-grey-border mb-10">
                {deviceTypeData && (
                  <PieChartTable
                    data={deviceTypeData.values}
                    dataKey="value"
                    title={"Device Type Breakdown"}
                    tableTitle={deviceTypeData.name}
                  />
                )}
              </div>
              {this.props.loadDeviceModelReport && (
                <div
                  className="text-center"
                  style={{ marginTop: "50px", marginBottom: "40px" }}
                >
                  <img alt="" src="/Spinner.gif" style={{ height: "48px" }} />
                </div>
              )}
              <div className="light-grey-border">
                {deviceModelData && (
                  <PieChartTable
                    data={deviceModelData.values}
                    dataKey="value"
                    title={"Model Breakdown"}
                    tableTitle={deviceModelData.name}
                  />
                )}
              </div>
            </div>
            <div style={{ flex: "20px" }}>&nbsp;</div>
            <div style={{ flex: "50%" }}>
              {this.props.loadingTop5OSBreakdown && (
                <div
                  className="text-center"
                  style={{ marginTop: "50px", marginBottom: "40px" }}
                >
                  <img alt="" src="/Spinner.gif" style={{ height: "48px" }} />
                </div>
              )}
              <div className="light-grey-border">
                {top5OSBreakDown && (
                  <PieChartTable
                    data={top5OSBreakDown.values}
                    dataKey="value"
                    title={"OS Breakdown"}
                    tableTitle={top5OSBreakDown.name}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      );
    else
      return (
        <div style={style} id="device-report-container">
          &nbsp;
        </div>
      );
  }
}
export default SegmentDeviceReport;



// WEBPACK FOOTER //
// ./src/components/Insights/distribution/SegmentDeviceReport.js